import {LOGIN, LOGIN_SUCCESS} from '../Types/User';


export const loginAction = (email, pwd) => {
    console.log("loginAction");
    let payload = new Object();
    payload.email = email;
    payload.pwd = pwd;
    return {
        type: LOGIN,
        payload:payload
    }
};


export const loginSuccessAction = (user) => {
    console.log("loginSuccessAction");
    
    return {
        type: LOGIN_SUCCESS,
        payload:user
    }
};



// WEBPACK FOOTER //
// ./src/Actions/UserActions.js